import React from 'react';
import classNames from 'classnames';

import SearchItem from './SearchItem/SearchItem';

import styles from './SearchList.module.scss';

interface Place {
  place_id: string;
  description: string;
}

interface SearchListProps {
  places: Place[];
  onSelect: (placeId: string, placeDescription: string) => void;
  selectedPlaceId: string | null;
  className?: string;
}

const SearchList: React.FC<SearchListProps> = ({
  places,
  onSelect,
  selectedPlaceId,
  className,
}) => {
  return (
    <ul
      className={classNames(styles.searchList, className)}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      {places.map((place) => (
        <SearchItem
          key={place.place_id}
          place={place}
          onSelect={onSelect}
          isSelected={place.place_id === selectedPlaceId}
        />
      ))}
    </ul>
  );
};

export default React.memo(SearchList);
